import { render } from "./NiceMessagesList.vue?vue&type=template&id=cd13e9ae"
import script from "./NiceMessagesList.vue?vue&type=script&lang=js"
export * from "./NiceMessagesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__